import axios from 'axios';

export default class IpClient {
  constructor(url) {
    this.client = axios.create({
      baseURL: url,
      timeout: 10000,
    });
  }

  async getIp() {
    let response;
    let error;
    try {
      response = await this.client.get('/');
    } catch (err) {
      error = new Error(`\`getIp\` ${err}`);
    }
    if (response && response.data) {
      return response.data;
    }
    if (error) {
      return Promise.reject(error);
    }
    return Promise.reject();
  }
}
